
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1706|35447|55745|79325)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
